/* eslint-disable react/no-danger */

/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useCallback, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import useScrollToTop from '../../hooks/useScrollToTop';
import * as AppPropTypes from '../../lib/PropTypes';

import Blocks from '../blocks/Blocks';
import ContactForm from '../forms/Contact';
import Header from '../headers/Header';

import styles from '../../../styles/pages/contact.module.scss';

const propTypes = {
    page: AppPropTypes.page.isRequired,
    className: PropTypes.string,
};

const defaultProps = {
    className: null,
};

const ContactPage = ({ page, className }) => {
    const { blocks, id = null } = page || {};
    useScrollToTop(page);

    const [success, setSuccess] = useState(false);

    const onSuccess = useCallback(() => {
        setSuccess(true);
    }, [setSuccess]);

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                    [styles.success]: success,
                },
            ])}
        >
            <Header page={page} />
            <div className={styles.inner}>
                <div className={styles.columns}>
                    <div className={styles.column}>
                        <Blocks blocks={blocks} />
                    </div>
                    <div className={styles.column}>
                        <ContactForm className={styles.form} onSuccess={onSuccess} pageId={id} />
                        <div className={styles.success}>
                            <FormattedMessage
                                defaultMessage="Thank you for your message!"
                                description="Contact form success message"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

ContactPage.propTypes = propTypes;
ContactPage.defaultProps = defaultProps;

export default ContactPage;
